module.exports = __webpack_public_path__ + "static/img/matthew-waring-jFflsRBFd6w-unsplash_thumb.9cb9aad.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/matthew-waring-jFflsRBFd6w-unsplash_thumb.png
// module id = Ddwd
// module chunks = 4